import { createAction } from "@reduxjs/toolkit";
import {
    GET_LINKS_IN_BATCH,
    SET_CURRENT_BATCH,
    STORE_BATCH_LINKS,
    STORE_BATCH_SHAPES,
    TOGGLE_BATCH_SELECTION,
    SHOW_BATCH_LIST_VIEW,
    SET_SELECTED_BATCH_IDS,
    SET_SELECTED_BATCH_REGULATIONS,
    BATCH_REGULATIONS_RECEIVED,
    GET_BATCH_REGULATIONS,
    DELETE_BATCH_REGULATION,
    TOGGLE_BATCH_ACTION_PERFORMED,
    toggleBatchSelectionAction,
    showBatchListViewAction,
    setSelectedBatchIdsAction,
    setSelectedBatchRegulationsAction,
    getBatchRegulationsAction,
    DeleteBatchRegulationAction,
    batchRegulationsReceivedAction,
    setCurrentBatchAction,
    storeBatchLinksAction,
    getLinksInBatchAction,
    storeBatchShapesAction,
    getDeleteBatchRegulationAction,
    GET_DELETE_BATCH_REGULATIONS,
    highlightedBatchLinksAction,
    HIGHLIGHTED_BATCH_LINKS,
    selectedBatchColumnsActions,
    SELECTED_BATCH_COLUMNS
} from "./types";
import { createOptionalAction } from "actions/helper";

export const toggleBatchSelection =
    createAction<toggleBatchSelectionAction["payload"]>(TOGGLE_BATCH_SELECTION);

export const showBatchListView =
    createAction<showBatchListViewAction["payload"]>(SHOW_BATCH_LIST_VIEW);

export const setSelectedBatchIds =
    createAction<setSelectedBatchIdsAction["payload"]>(SET_SELECTED_BATCH_IDS);

export const setSelectedBatchRegulations = createAction<
    setSelectedBatchRegulationsAction["payload"]
>(SET_SELECTED_BATCH_REGULATIONS);

export const getBatchRegulations =
    createOptionalAction<getBatchRegulationsAction["payload"]>(GET_BATCH_REGULATIONS);

export const getDeleteBatchRegulations = createAction<getDeleteBatchRegulationAction["payload"]>(
    GET_DELETE_BATCH_REGULATIONS
);

export const toggleBatchActionPerformed = createAction(TOGGLE_BATCH_ACTION_PERFORMED);

export const deleteBatchRegulation =
    createAction<DeleteBatchRegulationAction["payload"]>(DELETE_BATCH_REGULATION);

export const batchRegulationsReceived = createAction<batchRegulationsReceivedAction["payload"]>(
    BATCH_REGULATIONS_RECEIVED
);

export const setCurrentBatch = createAction<setCurrentBatchAction["payload"]>(SET_CURRENT_BATCH);

export const storeBatchLinks = createAction<storeBatchLinksAction["payload"]>(STORE_BATCH_LINKS);

export const getLinksInBatch = createAction<getLinksInBatchAction["payload"]>(GET_LINKS_IN_BATCH);

export const storeBatchShapes = createAction<storeBatchShapesAction["payload"]>(STORE_BATCH_SHAPES);

export const storeHighlightedBatchLinks =
    createAction<highlightedBatchLinksAction["payload"]>(HIGHLIGHTED_BATCH_LINKS);

export const setSelectedBatchColumns =
    createAction<selectedBatchColumnsActions["payload"]>(SELECTED_BATCH_COLUMNS);
